function amountSelectChange(selectAmount, inputAmount, selectAmountOldValue) {
    if (selectAmount.value === '-') {
        if (inputAmount.value === selectAmountOldValue) {
            inputAmount.value = '';
        }
        inputAmount.removeAttribute('hidden');
    }
    else {
        inputAmount.value = selectAmount.value;
        inputAmount.setAttribute('hidden', 'hidden');
    }
}

function donationTypeChange(checkboxAgreement, rowTerms) {
    const checkedRadio = document.querySelector('input[name="type"]:checked');
    const value = checkedRadio !== null ? checkedRadio.value : 'single';

    if (value === 'monthly') {
        checkboxAgreement.setAttribute('required', 'true');
        rowTerms.removeAttribute('hidden');
    }
    else {
        checkboxAgreement.removeAttribute('required');
        rowTerms.setAttribute('hidden', 'hidden');
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const selectAmount = document.getElementById('amount-predefined');
    const inputAmount = document.getElementById('amount');

    if (selectAmount !== null) {
        let selectAmountValue = selectAmount.value;
        selectAmount.addEventListener('change', (event) => {
            amountSelectChange(selectAmount, inputAmount, selectAmountValue);
            selectAmountValue = selectAmount.value;
        });
        amountSelectChange(selectAmount, inputAmount, selectAmountValue);
    }

    const typeInputs = document.querySelectorAll('input[name="type"]');
    const checkboxAgreement = document.getElementById('agree-terms');
    const rowTerms = document.getElementById('row-terms');

    if (checkboxAgreement !== null && typeInputs.length > 0) {
        typeInputs.forEach(typeInput => {
            typeInput.addEventListener('change', (event) => {
                donationTypeChange(checkboxAgreement, rowTerms);
            });
        });
        donationTypeChange(checkboxAgreement, rowTerms);
    }
    console.log(checkboxAgreement, rowTerms);
});
